define('common/ko/fn/property',['knockout', 'underscore', 'common/tools'], function(ko, _, tools) {

    /**
     * Use this to read an observable object's property as an observable
     *
     * Note. A nested observable can never be an array so these params should never both be passed
     *
     * @param {Object} [isArray] - Pass the Array constructor to indicate this is an array
     * @param {String} propertyName
     * @param {Boolean} [readWriteNestedObservable] - Default is true. Set to false if you don't to
     *                                                access the contents of a nested observable, but
     *                                                instead access the observable itself.
     */
    ko.subscribable.fn.property = _.memoize(
        function(arg1, arg2) {

            var wrappedObj = this,
                isArray = arg1 === Array,
                propertyName = arg1,
                readWriteNestedObservable = arg2,
                factory = ko.pureComputed;

            if (isArray) {
                propertyName = arg2;
                readWriteNestedObservable = null;
                factory = ko.pureComputedArray;
            }

            return factory({

                /**
                 * @return {*}
                 */
                read: function () {

                    var obj = wrappedObj(),
                        propertyVal;

                    if (!_.isObject(obj)) {
                        return null;
                    }

                    propertyVal = obj[ ko.unwrap(propertyName) ];

                    if (readWriteNestedObservable === false) {
                        return propertyVal;
                    }

                    return ko.unwrap(propertyVal);

                },

                /**
                 * Use to write directly to a nested property of an observable
                 *
                 * Will initialise the observable as an object on write if it is null or undefined
                 *
                 * @param {*} value
                 *
                 * @throws TypeError  When trying to write a non-empty non-object
                 */
                write: function(value) {

                    var obj = wrappedObj(),
                        unwrappedPropertyName = ko.unwrap(propertyName);

                    if (obj === null || obj === undefined) {
                        obj = {};
                    }

                    if (!_.isObject(obj)) {
                        throw new TypeError('Attempted to write "' + unwrappedPropertyName + '" of non-object');
                    }

                    if (ko.isObservable(obj[unwrappedPropertyName]) && readWriteNestedObservable !== false) {
                        obj[unwrappedPropertyName](value);
                        return;
                    }

                    if (value === undefined) {
                        delete obj[unwrappedPropertyName];
                    } else {
                        obj[unwrappedPropertyName] = value;
                    }

                    wrappedObj(obj);

                }

            });

        },
        function(arg1, arg2) {
            return tools.objToHash([this, arg1, arg2]);
        }
    );
});

